import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.string.link";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../services/apiService';
import tenantPickerMixin from '../../components/core/tenant/pickerMixin';
import { mapState, mapGetters } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'ViewAccountMgmtAccountMgmtAnnouncement',
  mixins: [tenantPickerMixin],
  data: function data() {
    return {
      formIsValid: false,
      maintenance: {
        start: new Date(),
        end: new Date(new Date() - -7 * 86400 * 1000),
        active: true,
        type: 'info',
        message: null,
        includeSubTenants: false,
        presentationType: 'banner',
        link: {
          url: null,
          message: this.$i18n_t('accMgmt.announcement.linkMessage')
        }
      },
      announcements: [],
      announcementsTbl: null,
      addAnnouncement: false,
      tableLoading: false,
      announcementSearch: null
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('app', ['UiTheme'])), mapGetters({
    sessionUser: 'authentication/user'
  })), {}, {
    buttons: function buttons() {
      return [{
        icon: 'fal fa-plus',
        action: 'add',
        title: this.$i18n_t('accMgmt.announcement.announcementCreate')
      }];
    }
  }),
  watch: {
    selectedTenantId: function selectedTenantId() {
      this.fetchAllSystemAnnouncements();
    }
  },
  mounted: function mounted() {
    this.loadTenants();
  },
  methods: {
    closeDialog: function closeDialog() {
      this.resetDialog();
    },
    revalidateForm: function revalidateForm() {
      this.$refs.mainForm.validate();
    },
    saveAnnouncement: function saveAnnouncement(data) {
      var announcementData = this.checkAnnouncementData(data);

      if (announcementData.message) {
        if (announcementData.id) {
          this.updateAnnouncement(announcementData);
        } else {
          this.createSystemAnnouncement(announcementData);
        }
      }
    },
    maintenanceToggleDate: function maintenanceToggleDate() {
      if (!!this.maintenance.start) {
        delete this.maintenance.start;
      } else {
        this.maintenance.start = new Date();
      }

      this.maintenance = cloneDeep(this.maintenance);
    },
    maintenanceDatePicked: function maintenanceDatePicked(dateObject) {
      this.maintenance.start = new Date(dateObject.from * 1000);
    },
    createSystemAnnouncement: function createSystemAnnouncement(data) {
      var _this = this;

      return ApiService.tenantCreateSystemAnnouncement(this.selectedTenantId, data).then(function () {
        _this.$snack(_this.$i18n_t('accMgmt.announcement.announcementCreated'), 'success');

        _this.handler();
      }).catch(function (error) {
        if (error.response && _this.$i18n_t("Error.".concat(error.response.data.message))) {
          _this.$snack(_this.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this.$snack(_this.$i18n_t('accMgmt.announcement.announcementCreatedFaild'), 'error');
        }
      });
    },
    fetchAllSystemAnnouncements: function fetchAllSystemAnnouncements() {
      var _this2 = this;

      ApiService.tenantFetchAllSystemAnnouncement(this.selectedTenantId).then(function (systemAnnouncements) {
        _this2.announcements = systemAnnouncements;
      }).catch(function (error) {
        if (error.response && _this2.$i18n_t("Error.".concat(error.response.data.message))) {
          _this2.$snack(_this2.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this2.$snack(_this2.$i18n_t('accMgmt.announcement.errorFindingAnnouncement'), 'error');
        }
      });
    },
    openEditDialog: function openEditDialog(announcement) {
      this.maintenance = announcement;
      this.addAnnouncement = true;
    },
    updateAnnouncement: function updateAnnouncement(announcement) {
      var _this3 = this;

      ApiService.tenantUpdateSystemAnnouncement(this.selectedTenantId, announcement).then(function () {
        _this3.$snack(_this3.$i18n_t('accMgmt.announcement.announcementUpdated'), 'success');

        _this3.handler();
      }).catch(function (error) {
        console.error(error);

        if (error.response && _this3.$i18n_t("Error.".concat(error.response.data.message))) {
          _this3.$snack(_this3.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this3.$snack(_this3.$i18n_t('accMgmt.announcement.announcementUpdatedFail'), 'error');
        }
      });
    },
    deleteAnnouncement: function deleteAnnouncement(announcement) {
      var _this4 = this;

      ApiService.tenantDeleteSystemAnnouncement(announcement.id).then(function () {
        _this4.$snack(_this4.$i18n_t('accMgmt.announcement.announcementDeleted'), 'success');

        _this4.removeFromUser(announcement);

        _this4.handler();
      }).catch(function (error) {
        console.error(error);

        if (error.response && _this4.$i18n_t("Error.".concat(error.response.data.message))) {
          _this4.$snack(_this4.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this4.$snack(_this4.$i18n_t('accMgmt.announcement.announcementDeletedFail'), 'error');
        }
      });
    },
    resetDialog: function resetDialog() {
      this.addAnnouncement = false;
      this.maintenance = {
        start: new Date(),
        end: new Date(new Date() - -7 * 86400 * 1000),
        active: true,
        type: 'info',
        message: null,
        includeSubTenants: false,
        presentationType: 'banner',
        link: {
          url: null,
          message: this.$i18n_t('accMgmt.announcement.linkMessage')
        }
      };
      this.fetchAllSystemAnnouncements();
    },
    checkAnnouncementData: function checkAnnouncementData(data) {
      if (!data.link.url) {
        data.link.message = null;
      }

      return data;
    },
    removeFromUser: function removeFromUser(announcement) {
      if (!this.sessionUser.properties) {
        return;
      }

      this.sessionUser.properties.announcements = this.sessionUser.properties.announcements.filter(function (a) {
        return parseInt(a) !== parseInt(announcement.id);
      });
      return ApiService.updateUser(this.sessionUser);
    },
    getUserAnnouncements: function getUserAnnouncements() {
      var _this5 = this;

      ApiService.getUserAnnouncements().then(function (result) {
        var now = new Date();
        _this5.$store.state.app.announcements = result.map(function (announcement) {
          // if expired set state to inactive
          var endDate = new Date(announcement.end);

          if (announcement.end && endDate < now && _this5.selectedTenantId) {
            ApiService.tenantUpdateSystemAnnouncementState(_this5.selectedTenantId, announcement);
            return null;
          }

          if (announcement && announcement.active) {
            return _objectSpread({}, announcement);
          }

          return null;
        }).filter(function (a) {
          return !!a;
        });
      }).catch(function (error) {
        if (error.response && _this5.$i18n_t("Error.".concat(error.response.data.message))) {
          _this5.$snack(_this5.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this5.$snack(_this5.$i18n_t('accMgmt.announcement.errorFindingUserAnnouncements'), 'error');
        }

        console.error(error);
      });
    },
    handler: function handler() {
      this.getUserAnnouncements();
      this.resetDialog();
    }
  }
};